import { ThunkDispatch } from 'redux-thunk'
import { selectHiddenToastsFromState } from 'src/app/Toast/redux/toast.selectors'
import { HidableToastNames } from 'src/enums'
import { RootState } from 'src/redux/createRootReducer'

export const SET_IS_TOAST_OPEN = 'app/toast/SET_IS_TOAST_OPEN'
export const SET_HIDE_TOAST = 'app/toast/SET_HIDE_TOAST'
export const SET_UNHIDE_TOAST = 'app/toast/SET_UNHIDE_TOAST'

export type ToastActions =
  | SetIsToastOpenAction
  | SetHideToastAction
  | SetUnhideToastAction

interface ToastProps {
  toastMessage?: React.ReactElement
  hidableToastName?: HidableToastNames
  inProgressColorScheme?: boolean
  failureColorScheme?: boolean
  partialSuccessColorScheme?: boolean
  hideImage?: boolean
  image?: React.ReactElement
  isInfinite?: boolean
  isDarkBackground?: boolean
  bulkToast?: boolean
}

export interface SetIsToastOpenAction {
  type: typeof SET_IS_TOAST_OPEN
  payload: {
    isToastOpen: boolean
    toastMessage?: React.ReactElement
    hidableToastName?: HidableToastNames
    inProgressColorScheme?: boolean
    failureColorScheme?: boolean
    partialSuccessColorScheme?: boolean
    hideImage?: boolean
    image?: React.ReactElement
    isInfinite?: boolean
    isDarkBackground?: boolean
    bulkToast?: boolean
  }
}

export const createSetIsToastOpen = (
  isToastOpen: boolean,
  toastProps?: ToastProps,
) => {
  return (
    dispatch: ThunkDispatch<RootState, void, SetIsToastOpenAction>,
    getState: () => RootState,
  ): void => {
    const hiddenToasts = selectHiddenToastsFromState(getState())
    if (
      toastProps?.hidableToastName !== undefined &&
      hiddenToasts.includes(toastProps.hidableToastName)
    ) {
      return
    }

    dispatch({
      type: SET_IS_TOAST_OPEN,
      payload: {
        isToastOpen,
        ...toastProps,
      },
    })
  }
}

export interface SetHideToastAction {
  type: typeof SET_HIDE_TOAST
  payload: {
    hidableToastName: HidableToastNames
  }
}
export const createSetHideToast = (hidableToastName: HidableToastNames) => {
  return (
    dispatch: ThunkDispatch<RootState, void, SetHideToastAction>,
  ): void => {
    dispatch({
      type: SET_HIDE_TOAST,
      payload: {
        hidableToastName,
      },
    })
  }
}

export interface SetUnhideToastAction {
  type: typeof SET_UNHIDE_TOAST
  payload: {
    hidableToastName: HidableToastNames
  }
}
export const createSetUnhideToast = (hidableToastName: HidableToastNames) => {
  return (
    dispatch: ThunkDispatch<RootState, void, SetUnhideToastAction>,
  ): void => {
    dispatch({
      type: SET_UNHIDE_TOAST,
      payload: {
        hidableToastName,
      },
    })
  }
}
